import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ConsumerSidebarComponent } from '../sidebar/consumer-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PickupThingsComponent } from '../../shared/components/pickup-things/pickup-things.component';
import { ActivitiesComponent } from '../../shared/components/activities/activities.component';
import { RequestStatusComponent } from './request-status/request-status.component';
import { RolesApiService, Role } from '@angular-workspace/services';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'app-consumer-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    ConsumerSidebarComponent,
    PageHeaderComponent,
    RequestStatusComponent,
    PickupThingsComponent,
    ActivitiesComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class ConsumerDashboardComponent implements OnInit {
  private rolesService = inject(RolesApiService);
  private router = inject(Router);
  private toasterService = inject(ToasterService);
  
  canAccess = false;
  isChecking = true;

  async ngOnInit(): Promise<void> {
    await this.checkConsumerRole();
  }

  private async checkConsumerRole(): Promise<void> {
    try {
      await this.rolesService.getRoles();
      const userRoles = this.rolesService.getUserRoles();

      if (userRoles && userRoles.length > 0) {
        // Get the highest role panel route
        const highestRolePanelRoute = this.rolesService.getHighestRolePanelRoute(userRoles);
        
        // If the highest role panel is not consumer, redirect to home
        if (!highestRolePanelRoute.startsWith('/consumer')) {
          // User doesn't have access to this panel, redirect to home
          console.log('User has different highest role, redirecting from consumer panel to home');
          this.toasterService.warning("You don't have access to some of the panels.");
          this.router.navigate(['/'], { replaceUrl: true });
          return;
        }
        
        // User has access to consumer panel
        this.canAccess = true;
      } else {
        // No roles found, allow access as fallback (consumer is default)
        this.canAccess = true;
      }
    } catch (error) {
      console.error('Error checking roles:', error);
      // On error, allow access (consumer is default fallback)
      this.canAccess = true;
    } finally {
      this.isChecking = false;
    }
  }
}
